import { useCallback } from 'react';

import { MicrophoneSelector } from '@repo/videa-notes';

import {
  mixpanelEvents,
  useTrackEventWithOptionalParams,
} from '@/utils/mixpanel';

import {
  useRecorderState,
  useRecordingHandlers,
} from '../../../context/VideaNotesRecordingContext';

export const RecordingFlowHeaderDropdown = () => {
  const { mediaBlobUrl } = useRecorderState();
  const { onMonitoringStreamChange } = useRecordingHandlers();
  const { trackEvent } = useTrackEventWithOptionalParams();

  const handlePreferredMicrophoneCheck = useCallback(
    (microphoneName: string | null) => {
      trackEvent(mixpanelEvents.videaNotesPreferredMicrophoneCheck, {
        preferredMicrophoneFound: microphoneName !== null,
        microphoneName,
      });
    },
    [trackEvent],
  );

  if (mediaBlobUrl) {
    return null;
  }

  return (
    <div className="vai-w-full vai-min-w-0">
      <MicrophoneSelector
        onMonitoringStreamChange={onMonitoringStreamChange}
        onPreferredMicrophoneCheck={handlePreferredMicrophoneCheck}
      />
    </div>
  );
};
